/* assets/sc-guard2.js
 * Simply Controlled — Dealer Guard (v2)
 *
 * Goals:
 * - Dealers (authorized): full access
 * - Guests (not logged in): redirect to login for /cart, /checkout*, and dealer-only pages
 * - Pending (logged in, not authorized): allow dealer-only pages so Liquid gate shows message; block /checkout*
 * - Block "Add to Cart" for guests only
 *
 * Notes:
 * - This is a CLIENT guard (UX + redirect).
 * - Server-side security must be done in Liquid via sc-dealer-gate.
 */
(function () {
  function isAuth() {
    return (window.SC_AUTH === true) ||
      (document.documentElement.getAttribute("data-sc-auth") === "true");
  }

  function isLoggedIn() {
    return (window.SC_LOGGED_IN === true) ||
      (document.documentElement.getAttribute("data-sc-logged-in") === "true");
  }

  function currentPath() {
    return (window.location && window.location.pathname) ? window.location.pathname : "/";
  }

  function isCheckoutPath(path) {
    return path.indexOf("/checkout") === 0;
  }

  function isCartPath(path) {
    return path === "/cart";
  }

  function isDealerPriceListPath(path) {
    return path === "/pages/dealer-price-list" ||
      path.indexOf("/pages/dealer-price-list/") === 0;
  }

  function isLumarisDealerPath(path) {
    return path === "/pages/lutron-lumaris-dealers" ||
      path.indexOf("/pages/lutron-lumaris-dealers/") === 0;
  }

  function isDealerOnlyPagePath(path) {
    return isDealerPriceListPath(path) || isLumarisDealerPath(path);
  }

  function loginUrl() {
    var returnTo = encodeURIComponent(window.location.pathname + window.location.search);
    return "/account/login?return_url=" + returnTo;
  }

  if (isAuth()) return;

  var path = currentPath();

  if (isDealerOnlyPagePath(path)) {
    if (!isLoggedIn()) {
      window.location.href = loginUrl();
      return;
    }
    // Logged-in but not authorized: allow load so Liquid gate shows the existing message.
  }

  if (!isLoggedIn()) {
    if (isCartPath(path) || isCheckoutPath(path)) {
      window.location.href = loginUrl();
      return;
    }
  }

  if (isLoggedIn() && !isAuth()) {
    if (isCheckoutPath(path)) {
      window.location.href = "/cart";
      try { alert("Your dealer account is pending approval."); } catch (_) {}
      return;
    }
  }

  document.addEventListener("submit", function (e) {
    if (isAuth()) return;

    var form = e.target;
    if (!form || form.nodeName !== "FORM") return;

    var action = (form.getAttribute("action") || "").toLowerCase();

    var isAddToCart =
      action.indexOf("/cart/add") === 0 ||
      action === "/cart" ||
      action.indexOf("/cart") === 0;

    if (!isAddToCart) return;

    if (!isLoggedIn()) {
      e.preventDefault();
      window.location.href = loginUrl();
      return;
    }
  }, true);
})();